import { buildApiActions } from '@/utils/vuex-api-utils';

export default {
  state: {
    fundingInquiries: [],
  },
  getters: {
    fundingInquiries: (state) => state.fundingInquiries,
  },
  ...buildApiActions({
    GET_FUNDING_INQUIRIES: {
      action: (ctx, payload) => ({
        method: 'get',
        url: `/businesses/${ctx.rootGetters.businessId}/funding-inquiries`,
        params: {
          type: payload.type,
          latest: payload.latest,
        },
        returnResponse: true,
      }),
      mutation: (state, { response }) => {
        state.fundingInquiries = response;
      },
    },
    CREATE_FUNDING_INQUIRY: {
      action: (ctx, payload) => ({
        method: 'post',
        url: `/businesses/${ctx.rootGetters.businessId}/funding-inquiries`,
        params: payload,
        returnResponse: true,
      }),
      mutation: (state, { response }) => {
        // Add the new inquiry to the beginning of the list
        state.fundingInquiries = [response, ...state.fundingInquiries];
      },
    },
  }),
};
